import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

// ==================== 三方服务配置 ====================
export function thirdPartyConfigList(data) {
  return axios.post(`${base.url}/business/thirdPartyConfig/list`, qs.stringify(data))
}
export function thirdPartyConfigListAll(serviceParentType) {
  return axios.post(`${base.url}/business/thirdPartyConfig/listAll`, qs.stringify({ serviceParentType }))
}
export function thirdPartyConfigAddOrUpdate(data) {
  return axios.post(`${base.url}/business/thirdPartyConfig/addOrUpdate`, qs.stringify(data))
}
export function thirdPartyConfigDeleteBatchIds(ids) {
  return axios.post(`${base.url}/business/thirdPartyConfig/deleteBatchIds`, qs.stringify({ ids }))
}
export function thirdPartyConfigStatus(ids, status) {
  return axios.post(`${base.url}/business/thirdPartyConfig/status`, qs.stringify({ ids, status }))
}